import filesize from "filesize";

export const humanizeFileSize = (byte) => {
  return filesize(byte || 0);
};
